import { renderSlot as _renderSlot, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["rows", "lang", "maxlength", "name", "disabled", "placeholder", "data-qa"]
const _hoisted_2 = {
  key: 1,
  class: "gfu-field__textarea gfu-field__readonly gfu-field__textarea--readonly",
  "data-qa": "text-area-field"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _normalizeProps(_guardReactiveProps({..._ctx.$attrs, ..._ctx.$props})), _createSlots({
    default: _withCtx(() => [
      (!$props.readOnly)
        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 0,
            ref: "input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model) = $event)),
            class: _normalizeClass([
                      'gfu-field__textarea',
                      `gfu-field__textarea--rows-${$props.rows}`,
                      {'gfu-field__textarea--no-resize': $options.isNoResizeable},
                      {'gfu-field__textarea--readonly': $props.readOnly},
                  ]),
            type: "text",
            rows: $props.rows,
            lang: $options.langCode,
            maxlength: $props.maxlength,
            name: _ctx.name,
            disabled: $options.isDisabled,
            placeholder: $props.placeholder,
            onKeyup: _cache[1] || (_cache[1] = (...args) => ($options.onKeyUp && $options.onKeyUp(...args))),
            "data-qa": 'text-area:'+ _ctx.name
          }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1)), [
            [_vModelText, _ctx.model]
          ])
        : _createCommentVNode("v-if", true),
      ($props.readOnly)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createTextVNode(_toDisplayString($options.readOnlyPlaceholderValue), 1 /* TEXT */)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots['field-description'])
      ? {
          name: "field-description",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "field-description")
          ]),
          key: "0"
        }
      : undefined
  ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
}